// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import "@epic-typeface/brutal";
import "@epic-ui/css-baseline";
import { Theme, ThemeProvider } from "@material-ui/core/styles";
import { StylesProvider } from "@material-ui/styles";
import { ThemeProvider as StyledComponentsThemeProvider } from "styled-components";
import { CssBaseline } from "@material-ui/core";
import { createEpicTheme } from "@epic-ui/theme";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { InstallationProgressPage } from "./pages/installation/InstallationProgressPage";
import { Provider } from "react-redux";
import store from "./store";
import NotFoundPage from "./pages/404";
import { AppBar } from "./components/common/AppBar";

function App(): JSX.Element {
  const theme: Theme = createEpicTheme({});

  return (
    <ThemeProvider theme={theme}>
      <StyledComponentsThemeProvider theme={theme}>
        <StylesProvider injectFirst>
          <CssBaseline />

          <Provider store={store}>
            <AppBar />
            <BrowserRouter basename="ui-helper">
              <Switch>
                <Route
                  exact
                  path="/installation/:groupId/progress"
                  component={InstallationProgressPage}
                />
                <Route component={NotFoundPage} />
              </Switch>
            </BrowserRouter>
          </Provider>
        </StylesProvider>
      </StyledComponentsThemeProvider>
    </ThemeProvider>
  );
}

export default App;
